import { css } from '@repo/pandacss/styled-system/css';

// Defined here so panda's static extractor can resolve them in template literal keys.
// Cross-file imports are not followed by panda's extractor.
export const LEGEND_ITEM_SELECTOR = '.star-rating-categories-legend-item';
export const PIE_ARC_SELECTOR = '.recharts-pie-sector';

// Marker classes toggled by JS (see Categories.tsx) so the hover/highlight styles are
// index-independent. Previously this file emitted ~100 `:has(...:nth-child(N))` rules
// (one pair per DEFAULT_COLORS index) purely to map a hovered/open legend item to its
// matching pie arc. Those rules bloated the shared Panda stylesheet even though most
// indices are never rendered. JS now marks the single active arc/legend directly.
export const CONTAINER_ACTIVE_CLASS = 'chart-has-active';
export const ARC_ACTIVE_CLASS = 'arc-active';
// `legend-active` is already styled in LegendItemComponent/Accordion (`&.legend-active`).
export const LEGEND_ACTIVE_CLASS = 'legend-active';

/**
 * Applied to the chart container. Arcs are fully opaque by default; when any legend
 * item or arc is active the JS adds CONTAINER_ACTIVE_CLASS to dim every arc, and
 * ARC_ACTIVE_CLASS to the one arc that should stay highlighted. The active legend
 * item's border is handled by its own `&.legend-active` rule.
 */
export const chartInteractionStyles = css({
  [`& ${PIE_ARC_SELECTOR}`]: { opacity: 1 },
  [`&.${CONTAINER_ACTIVE_CLASS} ${PIE_ARC_SELECTOR}`]: { opacity: 0.2 },
  [`&.${CONTAINER_ACTIVE_CLASS} ${PIE_ARC_SELECTOR}.${ARC_ACTIVE_CLASS}`]: { opacity: 1 },
});
